import PropTypes from 'prop-types';
import { ChickletSecondaryDisplayLabels } from '../../extensions/constants/BehaviorTypes';
import { useBehavior } from '../../extensions/hooks/useBehavior';
import ChickletFormattedProperty from './ChickletFormattedProperty';
import { useAssociatedObjectsCardContentContext } from '../../context/AssociatedObjectsCardContext';
import { getPropertyDefinition } from '../../hooks/useFetchPropertyDefinitions';
import { getPropertyValueFromProperties } from '../../helpers/propertiesHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const renderSecondaryProperty = ({
  properties,
  copyDisabled,
  object,
  objectTypeId,
  propertyDefinitions,
  propertyFormatters,
  propertyName
}) => {
  const propertyDefinition = getPropertyDefinition(propertyName, propertyDefinitions);
  if (!propertyDefinition) {
    return null;
  }
  const propertyValue = getPropertyValueFromProperties(properties, propertyName);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(ChickletFormattedProperty, {
      copyDisabled: copyDisabled,
      getAdditionalPropertyValue: additionalPropertyName => getPropertyValueFromProperties(properties, additionalPropertyName),
      objectId: `${object.id}`,
      objectTypeId: objectTypeId,
      propertyDefinition: propertyDefinition,
      propertyFormatters: propertyFormatters || {},
      propertyName: propertyName,
      propertyValue: propertyValue
    }, propertyName)
  }, propertyName);
};
export const ChickletSecondaryProperties = ({
  properties,
  object,
  objectTypeId
}) => {
  const {
    hasScope,
    isUngated,
    propertyDefinitions,
    propertyNames,
    readOnly,
    onEmailClick,
    onPhoneClick,
    onPreview,
    objectId: fromObjectId,
    objectTypeId: fromObjectTypeId
  } = useAssociatedObjectsCardContentContext();
  const getChickletSecondaryDisplayLabels = useBehavior(ChickletSecondaryDisplayLabels, objectTypeId, hasScope, isUngated);
  const {
    propertyFormatters,
    copyDisabled,
    additionalPrefixContent,
    additionalPostfixContent,
    hideSecondaryDisplayLabels
  } = getChickletSecondaryDisplayLabels({
    toObjectTypeId: objectTypeId,
    object,
    objectId: object.id,
    properties,
    propertyDefinitions,
    readOnly,
    isUngated,
    onEmailClick,
    onPhoneClick,
    onPreview,
    hasScope,
    fromObjectId,
    fromObjectTypeId
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [additionalPrefixContent, !hideSecondaryDisplayLabels && propertyNames.map(propertyName => renderSecondaryProperty({
      properties,
      copyDisabled,
      object,
      objectTypeId,
      propertyDefinitions,
      propertyFormatters,
      propertyName
    })), additionalPostfixContent]
  });
};
ChickletSecondaryProperties.propTypes = {
  object: PropTypes.object.isRequired,
  objectTypeId: PropTypes.string.isRequired,
  onEmailClick: PropTypes.func
};
export default ChickletSecondaryProperties;